import { TableCell } from '@mui/material';
import React, { useState } from 'react';
import InputMuiCustom from '../../../components/common/inputs/InputMuiCustom';

const ListInputRow = ({ item, index, isEdible }: any) => {
  const [render, setRender] = useState(false);

  const handleCalc = () => {
    const thickmm = item.rm_thick;
    const widthmm = item.rm_width;
    const lengthmm = item.rm_length;
    const noOfPc = item.rm_no_of_pc;
    const rm_grade = item.rm_grade;
    // if (!thickmm || !widthmm || !lengthmm) {
    //   return;
    // }

    const regexActions: any = {
      'MS ROD': function () {
        return Number(
          (7.86 * 3.14 * (widthmm || 0) * (widthmm || 0) * (lengthmm || 0)) /
            4000000,
        ).toFixed(3);
      },
      ERW: function () {
        return Number(
          (7.86 * 3.14 * (thickmm || 0) * (widthmm || 0) * (lengthmm || 0)) /
            1000000,
        ).toFixed(3);
      },
      CEW: function () {
        return Number(
          (7.86 * 3.14 * (thickmm || 0) * (widthmm || 0) * (lengthmm || 0)) /
            1000000,
        ).toFixed(3);
      },
      DEFAULT: function () {
        return Number(
          (7.86 * (thickmm || 0) * (widthmm || 0) * (lengthmm || 0)) / 1000000,
        ).toFixed(3);
      },
    };

    for (let regexStr in regexActions) {
      item.rm_strip_wt = 0;
      let regex: any = new RegExp(regexStr, 'i');
      if (regex.test(rm_grade)) {
        item.rm_strip_wt = regexActions[regexStr]();
        break;
      } else {
        item.rm_strip_wt = regexActions['DEFAULT']();
      }
    }

    item.rm_gross_wt =
      item.rm_strip_wt &&
      noOfPc &&
      Number(item.rm_strip_wt / noOfPc).toFixed(3);

    setRender((prev) => !prev);
  };

  return (
    <>
      <TableCell align="center">
        <InputMuiCustom
          type="text"
          variant="outlined"
          name="rm_grade"
          placeholder=""
          onBlur={(e) => {
            item.rm_grade = e.target.value;
            handleCalc();
          }}
          sx={{ maxWidth: '180px' }}
          defaultValue={item.rm_grade || null}
          InputProps={{
            readOnly: !isEdible[index],
          }}
        />
      </TableCell>

      <TableCell align="center">
        <InputMuiCustom
          type="number"
          variant="outlined"
          name="rm_thick"
          placeholder=""
          onChange={(e) => {
            item.rm_thick = +e.target.value;
            handleCalc();
          }}
          sx={{ maxWidth: '100px' }}
          value={item.rm_thick || null}
          InputProps={{
            readOnly: !isEdible[index],
          }}
        />
      </TableCell>
      <TableCell align="center">
        <InputMuiCustom
          type="number"
          variant="outlined"
          name="rm_width"
          placeholder=""
          onChange={(e) => {
            item.rm_width = +e.target.value;
            handleCalc();
          }}
          sx={{ maxWidth: '100px' }}
          value={item.rm_width || null}
          InputProps={{
            readOnly: !isEdible[index],
          }}
        />
      </TableCell>

      <TableCell align="center">
        <InputMuiCustom
          type="number"
          variant="outlined"
          name="rm_length"
          placeholder=""
          onChange={(e) => {
            item.rm_length = +e.target.value;
            handleCalc();
          }}
          sx={{ maxWidth: '100px' }}
          value={item.rm_length || null}
          InputProps={{
            readOnly: !isEdible[index],
          }}
        />
      </TableCell>

      <TableCell align="center">
        <InputMuiCustom
          type="number"
          variant="outlined"
          name="rm_strip_wt"
          placeholder=""
          sx={{ maxWidth: '100px' }}
          value={item.rm_strip_wt || null}
          InputProps={{
            readOnly: true,
          }}
        />
      </TableCell>

      <TableCell align="center">
        <InputMuiCustom
          type="number"
          variant="outlined"
          name="rm_no_of_pc"
          placeholder=""
          onChange={(e) => {
            item.rm_no_of_pc = +e.target.value;
            handleCalc();
          }}
          sx={{ maxWidth: '100px' }}
          value={item.rm_no_of_pc || null}
          InputProps={{
            readOnly: !isEdible[index],
          }}
        />
      </TableCell>

      <TableCell align="center">
        <InputMuiCustom
          type="number"
          variant="outlined"
          name="rm_gross_wt"
          placeholder=""
          sx={{ maxWidth: '100px' }}
          value={item.rm_gross_wt || null}
          InputProps={{
            readOnly: true,
          }}
        />
      </TableCell>
    </>
  );
};

export default ListInputRow;
